module.exports = __webpack_public_path__ + "img/img01.62249371.png";